var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "gfu-homepage-wrapper _grid _grid-cols-1 _grid-cols-24--l _grid-cols-24--xl _row-gap-6",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "_col-span-1 _col-span-5--l _col-span-4--xl _flexcol _ai-st _order-7 _order-1--l",
        },
        [
          _c(
            "home-section-title",
            { staticClass: "_mb-3", attrs: { "icon-name": "grid-horizontal" } },
            [_vm._v(_vm._s(_vm.Resources.Homepage.ProjectListsSectionTitle))]
          ),
          _vm._v(" "),
          _c("home-project-list"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "_col-span-1 _col-span-13--l _col-span-15--xl gfu-homepage-featured-projects _order-1 _order-2--l",
          attrs: { "data-qa": "homepage-section:Featured" },
        },
        [
          _c(
            "home-section-title",
            {
              staticClass: "gfu-homepage-featured-projects__title",
              attrs: { "icon-name": "fire" },
            },
            [_vm._v(_vm._s(_vm.Resources.Homepage.FeaturedSectionTitle))]
          ),
          _vm._v(" "),
          _c("featured-projects"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "_col-span-1 _col-span-6--l _col-span-5--xl _flexcol _ai-st _order-2 _order-3--l",
          attrs: { "data-qa": "homepage-section:Spotlight" },
        },
        [
          _c(
            "home-section-title",
            { staticClass: "_mb-3", attrs: { "icon-name": "lighthouse" } },
            [_vm._v(_vm._s(_vm.Resources.Homepage.SpotlightSectionTitle))]
          ),
          _vm._v(" "),
          _c("spotlight"),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasBanner
        ? _c(
            "div",
            { staticClass: "_col-span-1 _col-span-24--l _order-3 _order-4--l" },
            [
              _c("announcements", {
                attrs: {
                  "preview-banner-id": _vm.previewBannerId,
                  "data-qa": "home-page-box:InfoBanners",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "_col-span-1 _col-span-24--l _order-5 _order-6--l",
          attrs: { "data-qa": "homepage-section:Explore" },
        },
        [_c("explore-projects-section")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "_col-span-1 _col-span-24--l _order-4 _order-5--l",
          attrs: { "data-qa": "homepage-section:Rankings" },
        },
        [
          _c("projects-ranking", {
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c(
                      "home-section-title",
                      { attrs: { "icon-name": "trophy" } },
                      [
                        _vm._v(
                          _vm._s(_vm.Resources.Homepage.RankingsSectionTitle)
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "_col-span-1 _col-span-24--l _order-8" },
        [_c("home-platform-statistics")],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }